export const MSEnum = {
  /**
   * Trạng thái lọc thông báo
   */
  NotificationFilterState: {
    ALL: 1,
    UNREAD: 2,
  },

  /**
   * Loại thông báo
   */
  NotificationMessageState: {
    ALL: 1,
    ACTION: 2,
    SYSTEM: 3,
  },

  /**
   * Định dạng dữ liệu hiển thị
   */
  FormatType: {
    /// <summary>
    /// Loại mà không xử lý gì cả
    /// </summary>
    /// <remarks></remarks>
    None: 0,
    ///Định dạng cho tiền hạch toán
    ///Đơn giá
    UnitPrice: 1,
    ///Thành tiền quy đổi
    Amount: 2,
    ///-----------------------------------
    ///Hệ số, Tỷ lệ
    Rate: 3,
    ///Tỷ giá
    ExchangeRate: 4,
    ///Định dạng cho tiền ngoai te
    ///Đơn giá
    UnitPriceOC: 5,
    ///Thành tiền nguyên tệ
    AmountOC: 6,
    ///Hệ số, tỷ lệ phân bổ
    Allocation: 7,
    ///-----------------------------------
    ///Số lượng
    QuantityConvert: 8,
    //Số công
    WorkDay: 10,
    ///Số lượng
    Quantity: 11,
    //Kiểu chữ
    Text: 12,
    //Kiểu tích chọn
    Checkbox: 13,
    //Kiểu ngày tháng
    Date: 14,
    //Kiểu danh sách
    List: 15,
    //Kiểu thời gian
    Time: 16,
    // Join mảng theo dấu ;
    Join: 17,
    //Group Item
    GroupItem: 18,
    //Kiểu ngày/tháng/năm có giờ
    DateTime: 19,
    //Kiểu số không có định dạng sau dấu phẩy
    Number: 20,
    //Kiểu text nhưng trên grid khi click vào sẽ drilldown
    Drilldown: 21,
    //Format trạng thái
    Status: 22,
    //Format giới tính
    Gender: 23,
    //pvduy 12/04/2021 Format file size
    FormatFileSize: 24,
    //ntnghia 04/05/2021 Format tiến độ %
    Progress: 25,
    UserStatus: 26,
    //Định dạng dữ liệu html
    Html: 99,
    //Kiểu enum
    Enum: 100,
    // Danh sách role
    RoleList: 101,
    // Null
    Empty: 102,
  },
  /**
   * Trạng thái sắp xếp
   */
  SortStatus: {
    /**
     * Không sort
     */
    none: 0,
    /**
     * Giảm dần
     */
    desc: 1,
    /**
     * Tăng dần
     */
    asc: 2,
  },

  /**
   * Tên vai trò danh mục merchant
   */
  RoleCategoryMerchant: {
    MerchantAdmin: 0, // Merchant Admin
    TransactionManagement: 1, // Quản lý giao dịch
    ControlManagement: 2, // Quản lý đối soát
    Paymentlink: 3, // Paymentlink
    ComplaintAndRefund: 4, // Khiếu nại và hoàn tiền
    Setting: 5, // Thiết lập
  },
  /**
   * Trạng thái của form
   */
  FormState: {
    /**
     * Mode View
     */
    View: 0,
    /**
     * Thêm
     */
    Add: 1,
    /**
     * Sửa
     */
    Edit: 2,
    /**
     * Nhân bản
     */
    Duplicate: 4,
    /**
     * Thêm nhanh
     */
    QuickAdd: 5,
  },
  /**
   * Mode save truyền lên server để điều khiển
   */
  SaveMode: {
    Save: 0,
    SaveNew: 1,
    SaveView: 2, // pvduy 04/03/2021 cất tại trường hợp mode view
  },
  /**
   * Trạng thái tài sản
   * Modify by ĐVThi 08/03/2021: Làm chuẩn lại danh sách trạng thái của TS theo tài liệu BA
   * DEV nào sửa lại món này phải confirm lại devlead vì đây là gí trị chuẩn
   */
  AssetStatus: {
    UnUse: 99, // Chưa sử dụng
    Use: 1, //Đang sử dụng
    ReportBroken: 2, //Báo hỏng
    Broken: 3, //Hỏng
    Repair: 4, //Sửa chữa
    Maintain: 5, //Bảo dưỡng
    ReportLost: 6, //Báo mất
    Lost: 7, //Mất
    Cancel: 8, //Hủy
    RequestLiquidation: 9, //Đề nghị thanh lý
    Liquidated: 10, //Thanh lý
    Tranfering: 11, //Đang điều chuyển
  },
  /**
   * Mã lỗi service
   */
  ServiceResponseCode: {
    /**
     * Thành công
     */
    Success: 0,

    /**
     * Dữ liệu truyền lên không hợp lệ
     */
    InvalidData: 1,

    /**
     * Dữ liệu không tồn tại
     */
    NotFound: 2,

    /**
     * Cần người dùng xác nhận
     */
    RequireConfirm: 3,

    /**
     * Đăng nhập không thành công
     */
    NotAuthorize: 4,

    /**
     * Dữ liệu đã có phát sinh, không được xóa
     */
    Arisened: 5,

    /**
     * Không có quyền thực hiện hành động này
     */
    Forbiden: 403,

    /**
     * Gặp lỗi
     */
    Error: 99,

    /**
     * Lỗi hệ thống
     */
    Exception: 999,

    /**
     * 1 phần dữ liệu không hợp lệ
     * Sử dụng cho tình huống xóa, ghi sổ, bỏ ghi nhiều mà 1 phần thành công, 1 phần thất bại
     */
    PartInvalidData: 6,

    /**
     * Lỗi vượt quá số lượng tồn
     * Khi không đủ số lượng tồn thì trước khi cất vào database sẽ bắn lỗi về client để dev xử lý
     */
    OverQuantity: 7,
  },
  /**
   * Các loại kết quả validate trả về lỗi
   */
  ValidateResultType: {
    /**
     * Lỗi
     * Hiển thị thông báo và dừng lại
     */
    Error: 0,
    /**
     * Thông tin
     * Hiển thị thông báo và vẫn tiếp tục xử lý
     */
    Info: 1,
    /**
     * Cảnh báo - chỉ thông báo
     * Hiển thị thông báo và vẫn tiếp tục xử lý
     */
    Alert: 2,
    /**
     * Cảnh báo - cần xác nhận
     * Hiển thị confirm có tiếp tục xử lý không
     */
    Warning: 9,
  },

  /*
   * Enum trạng thái của đơn vi
   * nvhai 28/03/2021
   */
  OrganizationUnitStatus: {
    all: 2, // Tất cả
    Inactive: 1, // Ngừng theo dõi
    Active: 0, // Đang theo dõi
  },

  /*
   * Enum trạng thái của cơ cấu tổ chức
   * pvduy 06/01/2020
   */
  OrganizationStatus: {
    all: "Tất cả",
    Inactive: "Ngừng theo dõi",
    Active: "Đang theo dõi",
  },

  /*
   * Các trạng thái của kiểm đếm
   * pvduy 16/01/2021
   */
  TallyStatus: {
    Plan: "Lập kế hoạch kiểm đếm",
    Pending: "Đang kiểm đếm",
    Done: "Hoàn thành kiểm đếm",
  },
  /*
   * Các loại cấp phát cho (form cấp phát 1 tài sản)
   * nnphong 20/02/2021
   */
  AllocationFor: {
    Employee: "Nhân viên",
    Organization: "Phòng ban",
    AssetPosition: "Vị trí tài sản",
  },
  /**
   * Các loại file
   */
  StorageFileType: {
    /**
     * File tạm
     */
    Temp: 0,
    /**
     * Mẫu nhập khẩu
     */
    ImportTemplate: 5,
    /**
     * File đính kèm
     */
    Attachment: 6,
    /**
     * File stimul
     */
    StimulTemplate: 8,
  },
  /**
   * Các danh mục lưu trong bảng picklist
   */
  PickListType: {
    /**
     * vai trò công việc
     */
    JobRole: 1,
    /**
     * Xưng hô
     */
    Title: 2,
    /**
     * Đơn vị tính
     */
    Unit: 3,
    /**
     * Nguồn gốc tài sản
     */
    AssetRoot: 4,
  },
  /**
   * Loại cột - xác định editor
   */
  ColumnType: {
    Text: 0,
    Combobox: 1,
    Number: 2,
    Checkbox: 3,
    Datepicker: 5,
    Dropdown: 6,
    Template: 7,
    TextArea: 8,
    Enum: 9,
    UploadImage: 10,
    Radio: 11,
  },
  /**
   * Trạng thái của model
   */
  ModelState: {
    None: 0,
    Insert: 1,
    Update: 2,
    Delete: 3,
  },
  /**
   * Các loại action của nhật ký truy cập
   */
  AuditingLogAction: {
    /*
     * Đăng nhập
     */
    Login: 1,
    /*
     * Đăng xuất
     */
    Logout: 2,
    /**
     * Bảo dưỡng
     */
    Maintain: 5,
    /**
     * Hủy
     */
    Cancel: 8,
    /*
     * Thêm dữ liệu
     */
    Insert: 10,
    /*
     * Sửa dữ liệu
     */
    Edit: 11,
    /*
     * Xóa dữ liệu
     */
    Delete: 12,
    /*
     * Thêm dữ liệu hàng loạt
     */
    InsertMulti: 13,
    /*
     * Xóa dữ liệu hàng loạt
     */
    DeleteMulti: 14,
    /*
     * Nhập khẩu
     */
    Import: 16,

    //Điều chuyển
    Transfer: 17,

    // nhận điều chuyển
    GetTransfer: 18,

    // Từ chối nhận
    RefuseAccept: 19,

    //Đưa vào kho
    ToStock: 21,

    // đề nghị thanh lý
    RequestLiquidation: 22,
    //từ chối báo hỏng
    DenyBroken: 15,

    // Đưa tài sản vào sử dụng lại
    ReUse: 23,

    Repair: 24,

    // ghi tăng
    Increases: 25,

    // đánh dấu mất hàng loạt
    MultiDisposal: 26,

    // đánh dấu mất
    Disposal: 27,

    // đánh dấu hỏng hàng loạt
    MultiBroken: 28,

    // Thu hồi
    Reduce: 29,

    // Cấp phát
    Allocation: 30,
  },
  /**
   * Loại cơ cấu tổ chức
   * pvduy 02/02/2021: sửa lại enum do trước fix nhầm
   */
  OrganizationUnitType: {
    /**
     * Tổng công ty
     */
    Corporations: 1,
    /**
     * Tập đoàn
     */
    Group: 2,
    /**
     * Công ty con
     */
    Subsidiaries: 3,
    /**
     * Chi nhánh
     */
    Branch: 4,
    /**
     * Văn phòng đại điện
     */
    Representative: 5,
    /**
     * Văn phòng
     */
    Office: 6,
    /**
     * Trung tâm
     */
    Center: 7,
    /**
     * Phòng ban
     */
    Department: 8,
    /**
     * NHóm/tổ/đội
     */
    Team: 9,
    /**
     * Phân xưởng
     */
    Factory: 10,
  },
  /**
   * Nhập khẩu gì
   * maping với enum server
   */
  ImportType: {
    //Tài sản
    Asset: 1,
    //Nhà cung cấp
    Provider: 2,
    //Tài sản đang sử dụng
    AssetInUse: 3,
    //Loại tài sản
    AssetType: 4,
    //pvduy18/02/2021 Vị trí tài sản
    Location: 5,
    //Nhóm tài sản
    AssetCategory: 6,
    //Nhập khẩu yêu cầu thanh toán
    PaymentRequest: 7,
  },
  /**
   * Giới tính
   */
  GenderType: {
    Female: 0,
    Male: 1,
  },

  /**
   * Loại thẻ
   */
  PaymentType: {
    LocalCard: 1,
    Visa: 2,
    BankAccount: 3,
    Wallet: 4,
    QRCode: 5,
    Momo: 6,
    ViettelMoney: 7,
    ZaloPay: 8,
    Transfer: 9,
    ShopeePay: 10,
    AgribankAccount: 11, // tài khoản agribank
    // Tap2PayOne: 10, //Thẻ nội địa (Tap2Pay)
    // Tap2PayTwo: 11, //Thẻ quốc tế (Tap2pay)
  },
  // Mã đối tác thanh toán
  PartnerCode: {
    BankAccount_BillingSTB: "STB", // sacombank
    BankAccount_BillingVCB: "VCB", // vietcombank
    BankAccount_BillingBIDV: "BIDV", // BIDV
    BankAccount_BillingAGRIBANK: "AGRIBANK", // AGRIBANK
  },

  /**
   * Trạng thái giao dịch
   */
  TransactionStatus: {
    All: -1,
    Request: 0,
    Pending: 1,
    Failed: 2,
    Success: 3,
    Expiration: 4,
    Cancel: 5,
    RefundFailed: 6,
    PendingRefund: 7,
    Refunded: 8,
    Waitting: 99,
  },

  UserStatus: {
    Active: 0,
    NoActive: 1,
  },

  RoleUser: {
    Admin: 1,
    User: 2,
  },
  /**
   * Trạng thái hoàn tiền
   */
  RefundStatus: {
    All: -1,
    PendingRefund: 0,
    Refunded: 1,
    RefundFailed: 2,
  },

  /**
   * Loại dịch vụ
   */
  TypeService: {
    All: -1,
    PaymentGate: 0,
    Billing: 1,
    Transfer: 2,
  },

  /**
   * Loại nghiệp vụ, là trường ProcessType trong bảng Process
   * 0-Ghi tăng, 1- cấp phát, 2- thu hồi,
   * 3 điều chuyển, 4- sửa chữa, 5- bảo dưỡng,
   * 6- Đánh dấu hỏng, 7- báo hủy, 8- báo mất, 9- thanh lý
   */
  ProcessType: {
    // ghi tăng
    Increases: 0,
    // cấp phát
    Allocation: 1,
    // thu hồi
    Reduce: 2,
    // bảo dưỡng
    Maintenance: 3,
    // Đánh dấu hỏng
    Broken: 3,
    // hủy
    Cancel: 7,
    // báo mất
    LostAsset: 8,

    //Thanh lý
    Liquidation: 9,
    //ghi tăng số lượng
    IncrementQuantity: 10,
    //ghi giảm số lượng
    DecrementQuantity: 11,
  },

  /** ĐVThi 04/02/2021
   * Loại phát sinh, là trường OccurrenceType trong bảng UsageHistory
   * hiện chưa đủ giá trị, dev nào làm đến thì bổ sung Key và giá trị, hiện chưa biết key chính xác)
   * (Loại phát sinh: 0- Ghi tăng;1-Cấp phát;2-Thu hồi;3-Bảo dưỡng;4-Sửa chữa;5-Mất;6-Hỏng;7-Hủy;8-Thanh lý;9-Điều chuyển đi;10-Nhận điều chuyển;11-Từ chối nhận)
   */
  OccurrenceType: {
    //Ghi tăng
    Increament: 0,
    //Cấp phát
    Allocation: 1,
    //Thu hồi
    Reduce: 2,
    //Bảo dưỡng
    Maintain: 3,
    // Sửa chữa
    Repair: 4,
    //Mất
    Lost: 5,
    //hỏng
    Broken: 6,
    //Hủy
    Cancel: 7,
    // thanh lý
    Liquidation: 8,
    //Đưa vào sử dụng lại
    ReUse: 13,
    // đề nghị thanh lý
    RequestLiquidation: 14,
    //từ chối báo hỏng
    DenyBroken: 15,
    //ghi tăng số lượng
    IncrementQuantity: 16,
    //Điều chuyển vị trí
    TransferLocation: 17,
    //Điều chuyển đối tượng sử dụng
    TransferObject: 18,
    //Điều chuyển đi -Đang điều chuyển(Đơn vị quản lý)
    TransferManager: 19,
    //Điều chuyển từ chối (Đơn vị quản lý)
    TransferManagerRefuse: 20,
    //Điều chuyển nhận tài sản (Đơn vị quản lý)
    TransferManagerAccept: 21,
    //Báo hỏng
    ReportBroken: 22,
    //ghi tăng số lượng khi audit
    AuditIncrementQuantity: 25,
    //ghi giảm số lượng khi audit
    AuditDecrementQuantity: 26,
    //thay đổi đối tượng khi audit
    AuditTransferObject: 27,
    //thay đổi đối vị trí khi audit
    AuditTransferLocation: 28,
    //Báo mất
    ReportLost: 23,
    //Từ chối báo mất
    DenyLost: 24,
  },
  //Loại sửa chữa bảo dưỡng -pvduy 05/02/2021
  ScheduleType: {
    //sửa chưa
    Repain: 0,
    //bảo dưỡng
    Maintenance: 1,
  },
  // trạng thái bảo dưỡng tài sản  -pvduy 05/02/2021
  ScheduleStatus: {
    // kế hoạch
    Plan: 0,
    // đang thực hiện
    Process: 1,
    // hoàn thành
    Done: 2,
    //Bảo dưỡng
    Maintenance: 3,
  },
  // Tình trạng xử lý chênh lệch số lượng: 0-Chờ xử lý, 1: Đã xử lý, 2: Không xử lý'
  StatusQuantityResolve: {
    Pending: 0,
    Resolved: 1,
    NotResolve: 2,
  },

  /**
  * 
  Loại export đối soát
  */
  TypeExportControlReport: {
    ControlReportDetail: 1, // Biên bản đối soát chi tiết giao dịch
    PaymentListDetail: 2, // Danh sách thanh toán chi tiết giao dịch
  },

  StatusCombobox: {
    Active: 0, // đang hoạt động
    Inactive: 1, // ngừng theo dõi
    All: 2, // tất cả
  },
  /**
   * ĐVThi
   * Quy tắc đánh mã trên loại tài sản
   */
  EnumCodeType: {
    Company: 0,
    Branch: 1,
    Manual: 2,
  },
  EnumUnit: {
    Month: 0,
    Year: 1,
  },
  /**
   * ĐVThi
   * Cách quản lý tài sản
   */
  EnumByQuantity: {
    Code: 0,
    Quantity: 1,
  },

  /**
   * NTAnh2
   * Trạng thái của vị trí tài sản
   */
  EnumInActive: {
    Active: 0, // Đang theo dõi
    InActive: 1, // Ngừng theo dõi
  },

  /**
   * NTNghia
   * Giới tính nhân viên
   */
  EnumGender: {
    Male: 1, // Nam
    Female: 0, // Nữ
  },

  /**
   * NTNHAN - 18/2/2021
   * Có bảo hành hay không
   */
  EnumWarranty: {
    NopeWarranty: 0,
    Warranty: 1,
  },

  /**
   * NTNHAN - 18/2/2021
   * Có bảo hành hay không
   */
  EnumMaintenance: {
    NopeMaintenance: 0,
    Maintenance: 1,
  },
  /**
   * Loại customfield
   */
  CustomFieldType: {
    /**
     * Chữ
     */
    Text: 0,
    /**
     * Số
     */
    Number: 1,
    /**
     * Giá trị có/không
     */
    Bool: 2,
    /**
     * Ngày
     */
    Date: 3,
    // /**
    //  * Giờ
    //  */
    // Time: 4,
    /**
     * Danh sách
     */
    List: 10,
  },
  /**
   * pvduy 22/02/2021
   * Enum combobox đơn vị thời gian
   */
  EnumTimeUnit: {
    // Theo tháng
    Month: 0,
    // Theo năm
    Year: 1,
  },
  /**
   * pvduy 22/02/2021
   * Enum combobox cấp phát theo
   */
  AllocationType: {
    //Cấp phát theo nhân viên
    AllocationByEmployee: 0,
    //Cấp phát theo phòng ban
    AllocationByOrganization: 1,
  },
  /**
   * Filter header của grid
   */
  FilterHeader: {
    Contains: "contains",
    Notcontains: "notContains",
    StartsWith: "startsWith",
    EndsWith: "endsWith",
    Null: "is null",
    NotNull: "is not null",
    Equals: "=",
    NotEquals: "!=",
    GreaterThan: ">",
    GreaterThanEquals: ">=",
    LessThan: "<",
    LessThanEquals: "<=",
    Between: "[]",
  },

  /*
      Trạng thái điều chuyển
    */
  TransferStatus: {
    Transfering: 0, //Đang điều chuyển
    Received: 1, //Đã nhận tài sản
    Cancelled: 2, //Từ chối
  },

  /**
   * Đối tượng điều chuyển (Khi điều chuyển đối tượng sử dụng)
   * CreatedBy: NTAnh2 (25/03/2021)
   */
  TransferObjectType: {
    // Nhân viên
    Employee: 0,
    // Phòng ban
    OrganizationUnit: 1,
  },

  TransferSearchType: {
    EmployeeOwner: 1,
    OrganizationUnitOwner: 2,
    Location: 3,
    ManagementUnit: 4,
  },

  /*
      Trạng thái kiểm kê
    */
  AuditStatus: {
    New: 0, //Chưa thực hiện
    Processing: 1, //Đang thực hiện
    Done: 2, //Đã thực hiện
  },
  /*
      Trạng thái kiểm kêcủa tài sản
    */
  AssetAuditStatus: {
    New: 0, //Chưa kiểm kê
    Done: 1, //Đã kiểm kê
  },
  /*
      Loại kiểm kê
    */
  AuditType: {
    Detail: 0, //Kiểm kê chi tiết
    Quantity: 1, //Kiểm kê số lượng
  },

  AuditChange: {
    NoChange: 0,
    Changed: 1,
  },

  AuditAssetQuality: {
    Good: 0, //Sử dụng tốt
    Repair: 1, //Hỏng cần sử chữa
    Liquidation: 2, //Hỏng cần thanh lý
  },

  /**
   * Trạng thái lao động
   * */
  EmployeeStatus: {
    /**
     * Đang làm việc
     */
    Working: 1,
    /**
     * Đã nghỉ việc
     */
    Quit: 2,
    /**
     * Ngừng theo dõi
     */
    NotFollowing: 3,
  },

  /**
   * Trạng thái người dùng bên amis paltform
   * */
  UserAmisStatus: {
    /**
     * chưa kích hoạt
     */
    NotActiviti: 1,
    /**
     * chờ xác nhận
     */
    WaitConfirm: 2,
    /**
     * Đang hoạt động
     */
    Working: 3,
    /**
     * Ngừng kích hoạt
     */
    NotFollowing: 4,
    /**
     * Đã bị xóa
     */
    Deleted: 5,
  },

  /**
   * Các hàm ở footer cần xử lý
   */
  FooterCommand: {
    /// <summary>
    /// Sum dữ liệu đang hiển thị
    /// </summary>
    Sum: "sum",
    /// <summary>
    /// Sum tất cả dữ liệu trong store
    /// </summary>
    SumAll: "sumAll",
    /// <summary>
    /// Trung bình
    /// </summary>
    Avg: "avg",
    /// <summary>
    /// Nhỏ nhất
    /// </summary>
    Min: "min",
    /// <summary>
    /// Lớn nhất
    /// </summary>
    Max: "max",
    /// <summary>
    /// Text custom
    /// </summary>
    Text: "text",
  },
  /*
   * Các kỳ liên quan đến khoảng thời gian phục vụ cho control DateRange
   * CreatedBy DNThang - 02.07.2019
   */
  Period: {
    ThisDay: 20,
    ThisWeek: 30,
    FirstWeekToPresent: 31,
    ThisMonth: 45,
    FirstMonthToPresent: 46,
    ThisQuarter: 60,
    FirstQuarterToPresent: 61,
    ThisYear: 500,
    FirstYearToPresent: 501,
    SixFirstMonth: 75,
    SixLastMonth: 70,
    // Các tháng trong năm
    January: 1,
    February: 2,
    March: 3,
    April: 4,
    May: 5,
    June: 6,
    July: 7,
    August: 8,
    September: 9,
    October: 10,
    November: 11,
    December: 12,

    //Qúy
    FiscalI: 100, //Qúy 1
    FiscalII: 200,
    FiscalIII: 300,
    FiscalIV: 400,

    Yesterday: 21,
    LastWeek: 35,
    LastMonth: 50,
    LastQuarter: 65,
    LastYear: 80,

    Tomorrow: 25,
    NextWeek: 40,
    NextMonth: 55,
    NextQuarter: 66,
    NextYear: 90,
    // FourLastWeek: 41,
    // ThreeLastYear: 85,
    Custom: 0,
  },

  /**
   * Các loại kỳ báo cáo
   */
  PeriodType: {
    Month: 1,
    Quarter: 2,
    Year: 3,
  },

  /*
   * Chọn khổ giấy
   * CreatedBy nnlam 20.04.2021
   */
  ChoosePageType: {
    A4_65: 0,
    A5_40: 1,
    TwoTem: 2,
    ThreeTem: 3,
    Tze251: 4,
    TzeS261: 7,
    A4_21: 5,
    A4_24: 6,
  },

  /**
   * Chọn loại đơn vị trong báo cáo theo đơn vị
   * CreatedBy: NTAnh2 (22/04/2021)
   */
  ReportUnitType: {
    // là đơn vị quản lý
    Management: 1,
    // là đơn vị sử dụng
    UseOrg: 0,
  },

  /**
   * Chọn nhóm trạng thái tài sản trong báo cáo theo đơn vị
   * CreatedBy: NTAnh2 (22/04/2021)
   */
  GroupAssetStatus: {
    // tất cả trạng thái
    All: 0,
    // đang sử dụng
    Use: 1,
    // chưa sử dụng
    UnUse: 2,
    // đã hỏng, đang sửa chữa, đang bảo dưỡng
    GroupBrokenRepairMaintain: 3,
    // đã mất, đã hủy, đã thanh lý
    GroupLostCancelLiquidated: 4,
    // khác (báo hỏng, báo mất, đề nghị thanh lý, đang điều chuyển)
    Other: 5,
  },

  /**
   * Các loại báo cáo
   * created by bnduc 4.9.2019
   */
  ReportTypeUI: {
    Stimul: 1,
    Html: 2,
    Dynamic: 5,
    Merge: 8, //mẫu trộn
  },
  /**
   * Enum chứa loại định dạng in
   */
  EnumFormatPrintType: {
    Pdf: 0, // định dạng Pdf
    Doc: 1, // định dạng Doc
    Excel: 2, // định dạng Excel
  },

  // Định dạng xuất khẩu dữ liệu
  ExportType: {
    Pdf: 1,
    Excel: 2,
  },

  /**
   * Tháng
   */
  EnumMonth: {
    January: 1,
    February: 2,
    March: 3,
    April: 4,
    May: 5,
    June: 6,
    July: 7,
    August: 8,
    September: 9,
    October: 10,
    November: 11,
    December: 12,
  },

  /**
   * Kiểm kê
   */
  EnumAuditStatus: {
    None: 0,
    Auditing: 1,
    Done: 2,
  },
  /**
   * Kiểu lấy data role
   */
  EnumGetDataRoleType: {
    HasJson: 0,
    NoneJson: 1,
  },

  /**
   *  Định dạng trạng thái người dùng bên Amis
   */
  AmisUserStatus: {
    NotTriggered: 1,
    WaitConfirm: 2,
    Working: 3,
    StopTriggered: 4,
  },

  /*
   * Loại màn hình
   */
  FormType: {
    //Danh sách
    List: 1,
    //Tìm nhanh
    QuickSearch: 2,
  },

  /*
   * Nhóm theo cột màn hình chi tiết kiểm kê
   */
  GroupType: {
    // Loại tài sản
    AssetType: 1,
    // Vị trí tài sản
    Location: 2,
    // Phòng ban sử dụng
    OrganizationUnit: 3,
  },

  /**
   * Tình trạng xử lý (kiểm kê)
   */
  StatusResolve: {
    // Chưa xử lý
    NotResolve: 0,
    // Đã xử lý
    Resolved: 1,
  },

  /**
   * Chất lượng tài sản thực tế (kiểm kê)
   */
  QualityReal: {
    // Sử dụng tốt
    Good: 0,
    // Hỏng cần sửa chữa
    BrokenRepair: 1,
    // Hỏng cần thanh lý
    BrokenLiquidation: 2,
  },
  /**
   * Các type summary của xuất khẩu
   */
  ExportSummaryType: {
    /*
     * Sum từ source
     */
    Sum: 1,
    /*
     * Trung bình
     */
    Avg: 2,
    /*
     * Nhỏ nhất
     */
    Min: 3,
    /*
     * Lớn nhất
     */
    Max: 4,
    /*
     * Text custom
     */
    Text: 5,
    /*
     * Dữ liệu sẽ trả trong data luôn
     */
    Remote: 6,
  },

  /**
   * Xác thực hai bước
   */
  Twofactor: {
    /**
     * bằng enail
     */
    Email: 1,
    /**
     * Bằng GoogleAuthenticator
     */
    GoogleAuthenticator: 2,

    /**
     *  bằng số điện thoại
     */
    PhoneNumber: 3,

    /**
     * Liên hệ Misa Support
     */
    MisaSupport: 4,
  },

  /**
   * Enum trang thái giao dịch thanh toán
   * Map với enum trong DB
   */
  TransactionControlType: {
    // Yêu cầu thanh toán
    PaymentRequired: 0,

    // Đang xử lý giao dịch
    HandlingTransaction: 1,

    // Thanh toán thất bại
    PaymentFail: 2,

    // Thanh toán thành công
    PaymentSuccess: 3,

    // Hết hạn thanh toán
    PaymentExpired: 4,

    // Hủy giao dịch
    PaymentCancle: 5,
  },

  /**
   * Enum trang thái đối soát
   */
  CrossCheckingType: {
    Processing: 0,

    Done: 1,
  },

  /**
   * Enum trang thái đối soát theo tháng
   */
  CrossCheckingTypeByMonth: {
    Processing: 0,

    Done: 1,
  },

  /**
   * Enum trang thái kết quả khi đăng ký
   */
  RegisterErrorCode: {
    // Tạo mới misaId và thiết lập mk
    NewAccount: 1,

    // Kích hoạt tài khoản(sđt)
    ActivePhone: 2,

    // Kích hoạt tài khoản(email)
    ActiveEmail: 3,

    // Kích hoạt tài khoản và thiết lập mk(sđt)
    ActivePhoneAndPassword: 4,

    // Kích hoạt tài khoản và thiết lập mk(email)
    ActiveEmailAndPassword: 5,
  },

  /**
   * Enum trang thái định danh
   */
  IdentifyStatus: {
    // đăng ký mới
    NewAccount: 1,

    // Đã gửi định danh
    IdentifierSent: 2,

    // Đã phê duyệt
    Approved: 3,

    // Từ chối phê duyệt
    ApprovedDenied: 4,
  },

  /*
    Loại hình kinh doanh
  */
  BusinessType: {
    Publicschool: 0, //Trường công lập
    Privateschool: 1, //Trường dân lập
    Enterprise: 2, //Doanh nghiệp
    Personal: 3, //Hộ kinh doanh
  },

  /**
   * Loại dịch vụ
   */
  BusinessServiceType: {
    Normal: 1, //Dịch vụ thường
    Special: 2, //Dịch vụ đặc thù
    PublicService: 3, // Dịch vụ công
  },

  /*
    Loại giấy tờ của người đại diện pháp luật (1: CMT, 2: CCCD, 3: Hộ chiếu)'
  */
  LegalRepresentativeIdentityType: {
    CMT: 1,
    CCCD: 0,
    Passport: 2,
  },

  /**
   * Loại CCCD/CC chi tiết
   */
  IdCardType: {
    CCCD: 1, // Căn cước công dân
    CC: 2, // Căn cước
  },

  /**
   * Mã lỗi trả về JetpayId
   */
  JPIdErrorCode: {
    Success: "200",

    // Email chưa được kích hoạt
    EmailNotActive: "104",

    //Email đã được đăng ký tài khoản
    EmailUsed: "105",

    //Số điện thoại chưa được kích hoạt
    PhonelNotActive: "106",

    //Số điện thoại đã được đăng ký tài khoản
    PhonelUsed: "107",

    //Tài khoản bật xác thực 2 lớp
    Twofactor: "122",

    // Không tìm thấy người dùng
    UserNotFound: "113",

    //tài khoản chưa có mật khẩu và chưa kích hoạt
    NotActiveAndNoPassWord: "130",

    //tài khoản chưa đăng ký thông tin đơn vị
    UnRegisteredInforUnit: "131",
  },

  /**
   * Loại chức vụ
   */
  JobTitle: {
    /**
     * Chủ tịch hội đồng quản trị
     */
    President: 0,

    /**
     * Phó chủ tịch hội đồng quản trị
     */
    VicePresident: 1,

    /**
     *  Tổng giám đốc
     */
    GeneralDirector: 2,

    /**
     * Phó tổng giám đốc
     */
    DeputyGeneralDirector: 3,

    /**
     * Giám đốc
     */
    Director: 4,

    /**
     * Phó giám đốc
     */
    DeputyDirector: 5,

    /**
     * Kế Toán trưởng
     */
    ChiefAccountant: 6,
  },

  //Loại thông tin đơn vị
  OrgType: {
    //Công ty mẹ
    ParentCompany: 1,
    //Chi nhánh
    Branch: 2,
    //Công ty con
    Subsidiary: 3,
    //văn phòng đại diện.
    RepresentativeOffice: 4,
  },

  // Loại giấy tờ
  CitizenType: {
    // căn cước công dân
    CCCD: 1,

    // chứng minh nhân dân
    CMND: 2,

    // hộ chiếu
    Passport: 3,
  },

  //Trạng thái của payment link
  PaymentLinkStatus: {
    //Chờ thanh toán
    WaitForPay: 0,
    //Đã thanh toán
    Paid: 1,
    //Hết hạn
    Expired: 2,
  },

  //Loại payment link
  PaymentLinkType: {
    //Link mua hàng
    PurchaseLink: 0,
    //Link thanh toán hóa đơn
    BillPaymentLink: 1,
  },

  // Loại hình kinh doanh
  MerchantType: {
    None: -1, //Không có
    School: 0, // Trường học (Công lập)
    Enterprise: 1, // Doanh nghiệp
    Store: 2, // Cửa hàng
    Restaurant: 3, // Nhà hàng
    Other: 4, //Khác
    PrivateSchool: 5, // Trường học (Tư thục)
  },

  /**
   * Loại thông tin hồ sơ yêu cầu cập nhật
   */
  TypeInfoProfileRequestUpdate: {
    UnitInformation: 1, // Thông tin đơn vị
    DecisionEstablishmentSchool: 2, // Quyết định thành lập trường
    PrincipalInformation: 3, // Thông tin hiệu trưởng
    CallbackMerchant: 4, //người Thanh toán, đối soát
    AdminAccount: 5, // Tài khoản quản trị
    ServiceRequest: 6, // Yêu cầu dịch vụ
    FeePlan: 7, // Chính sách phí
    HeadAccounting: 8, // Thông tin kế toán trưởng
    PaymentControlInfo: 9, // Thông tin tài khoản thanh toán
    BusinessRegistration: 10, // Đăng ký kinh doanh (MỚI - cho trường tư thục)
    LegalRepresentative: 11, // Người đại diện pháp luật (MỚI - cho trường tư thục)
    SigningContract: 12, // Người ký hợp đồng
    BusinessRegistration_RegisterService: 13, // Danh sách hàng hoá, giá trị hàng hoá trong BusinessRegistration - nhưng lưu trên bảng registerService
  },

  /**
   * Tiến trình tạo đơn yêu cầu cập nhật
   */
  ProfileRequestUpdateProcess: {
    CreateForm: 0, // Tạo đơn
    SignForm: 1, // Ký đơn
    ConfirmInfo: 2, // Xác nhận thông tin
    Completed: 3, // Đã xác nhận
  },

  ProfileRequestUpdateStatus: {
    Pending: 0,
    Reject: 1,
    Approved: 2,
  },

  /**
   * Mức độ rủi ro
   */
  RiskLevel: {
    Low: 0,
    Medium: 1,
    High: 2,
  },

  /**
   * Kênh đăng ký hồ sơ
   */
  EnumRegisterChannel: {
    RegistedByCustomer: 0, // Khách hàng tự gửi hồ sơ
    RegistedBySale: 1, // Đăng ký bởi NVKD
    ReceivedBySale: 2, // Tiếp nhận bởi NVKD
    RegistedFromLandingPage: 3, // Đăng ký từ landingpage
    RegistedFromEmis: 4, // Đăng ký từ EMIS
  },

  /**
   * Kênh thanh toán
   */
  ChannelPayment: {
    None: -1,
    Offline: 1, // Trực tiếp
    Online: 2, // Online
  },

  /**
   * Cấp học
   */
  SchoolLevel: {
    Other: 0, // Khác
    Preschool: 1, // Mầm non
    PrimarySchool: 2, // Tiểu học
    SecondarySchool: 3, // THCS
    HighSchool: 4, // THPT
    InterLevelSchool: 5, // Liên cấp
    KinderGarten: 6, // Mẫu giáo
    EduCenter: 7, // Trung tâm GD
    CollegeUniversity: 8, // Cao đẳng, Đại học
  },

  // Loại khách hàng
  TypeProfile: {
    Normal: 0, // Bình thường
    IsRisk: 1, // rủi ro cao
    HighRisk: 2, // Rủi ro rất cao
    Virtual: 3, // hồ sơ ảo
    NoNeed: 4, // KH không có nhu cầu
    More: 5, // khác
    Invalid: 6, // Hồ sơ không hợp lệ
  },

  /**
   * Loại cấu hình phương thức
   * 0: Trực tiếp tại quầy
   * 1: Online
   */
  ConfigMethodType: {
    configOff: 0,
    configOnline: 1,
  },

  // Đối tượng chịu phí
  IncurTypeFee: {
    None: -1, //Tính phí cả 2
    Customer: 1, //Khách hàng của merchant
    Merchant: 0, //Merchant
  },

  /**
   * Trạng thái đơn vị JetPay
   * 0:Đăng ký Merchant
   * 1:Đang nộp hồ sơ
   * 2:Đang cập nhật thông tin bổ sung cho phần rủi ro
   * 3:Chờ kinh doanh phê duyệt
   * 4:Kinh doanh từ chối
   * 5:Chờ giám sát vận hành phê duyệt
   * 6:Giám sát vận hành từ chối
   * 7:Chờ giám đốc phê duyệt
   * 8:Giám đốc từ chối
   * 9:Phê duyệt
   * 10: Chờ pháp chế phê duyệt
   * 11: Pháp chế yêu cầu cập nhật lại
   * 12: NVKD tiếp nhận hồ sơ
   * 13: NVKD hủy hồ sơ trường hợp khách hàng đky mới nhưng không thực sự có nhu cầu  (Tạm thời bỏ không dùng)
   */
  MerchantStatus: {
    RegisterNew: 0,
    Applying: 1,
    UpdatingRiskInfo: 2,
    WaitingEmployeeApprove: 3,
    EmployeeDecline: 4,
    WaitingMonitorApprove: 5,
    MonitorDecline: 6,
    WaitingManagerApprove: 7,
    ManagerDecline: 8,
    Approve: 9,
    WaitingLegislationApprove: 10,
    LegislationDecline: 11,
    SaleReceived: 12,
    SaleCancel: 13, // Tạm thời bỏ không dùng
  },

  // Trạng thái hoạt động của hồ sơ
  // 0: Ngừng hoạt động
  // 1: đang hoạt động,
  // 2: Tạm khoá,
  // 4: Chờ cấp tài khoản
  MerchantIsActive: {
    IsActive: 1,
    TemporarilyLocked: 2,
    StopWorking: 0,
    WaitingForAccountLevel: 4,
  },

  /**
   * Cấu hình loại webhook dành cho thiết lập kết nối
   * Createdby: dbhuan 24/02/2022
   *
   * MisaEshop : 1
   * MisaCukCuk: 2
   * MisaMeinvoice: 3
   * MisaEmis: 4
   * Jetpayvn: 5
   * WebsiteDiffirent: 6
   * MemasWordpress: 7
   */
  MemasSettingWebType: {
    MisaEshop: 1,
    MisaCukcuk: 2,
    MisaMeinvoice: 3,
    MisaEmis: 4,
    Jetpayvn: 5,
    WebsiteDiffirent: 6,
    MemasWordpress: 7,
  },
  /**
   * Trạng thái của yêu cầu thanh toán
   */
  PaymentRequestStatus: {
    Create: 1,
    Sending: 2,
    Sent: 3,
    Open: 4,
    Expired: 5,
    Proscess: 6,
    Paid: 7,
    PaidFail: 8,
    Edited: 9,
    PaidJetPay: 10,
  },
  /**
   * Loại khách hàng
   */
  CustomerType: {
    Individual: 1,
    Organization: 0,
    OrgUndefined: -1,
  },
  /**
   * Trạng thái khoản thu
   */
  CollectionPeriodStatus: {
    Create: 1, /// 1: Kỳ tạo mới
    Processing: 2, /// 2: đang thu
    Done: 3, /// đã thu
  },
  /**Trạng thái import file */
  ImportStatus: {
    Valid: 1,
    Invalid: 0,
  },

  // Loại hồ sơ cá nhân
  PersonalType: {
    Principal: 0, // Hiệu trưởng
    LegalRepresentative: 1, // Người đại diện pháp luật
    SigningContract: 2, // Người ký hợp đồng
    HeadAccounting: 3, // Kế toán trưởng
    CallbackMerchant: 4, // Người đối soát
    RegisteredUser: 5, // Người đăng ký
  },
  // Trạn thái đối soát thanh toán cho merchant
  MerchantTransactionControlStatus: {
    /// Chưa chốt só liệu
    NotConfirm: 1,
    /// Đã chốt (Chưa thanh toán)
    UnPaid: 2,
    /// Đã thanh toán
    Paid: 3,
    //Đang xác nhận đối soát
    Confirming: 5,
  },
  ///1-Giao dịch thành công, 2-Giao dịch kỳ trước thành công kỳ này, 3-Giao dịch bù trừ, 4-Giao dịch nghi ngờ gian lận, 5-Giao dịch gian lận,- 6-Giao dịch khiếu nại
  MerchantTransactionControlTransactionType: {
    Success: 1,
    SuccessPrevious: 2,
    Compensate: 3, // bù trừ
    SuspectedFraud: 4,
    Cheat: 5,
    AppealAgain: 6,
    Refund: 7,
    MoneyNotEnough: 9, // Thành công chưa có tiền về
  },
  MerchantTransactionSettlementStatus: {
    // chưa đối soát
    UnContested: 0,
    // đã đối soát
    Contested: 1,
  },
  /**Tiền đang ở */
  StatusMoney: {
    Partner: 1,
    JETPAY: 2,
    Merchant: 3,
  },
  EnumProfileUpdateRequestSource: {
    UNKNOW: 0,
    REVIEW: 1,
  },
};
